import { httpClient } from "../../httpClient";
import { Employee } from "../../../store";

type Payload = {
    email: string;
    location: string;
    userNtLogin: string;
    managerEmail: string;
    vpemail: string;
    svpemail: string;
    secondManagerEmail: string;
};

type Data = any;

export async function postEmployee(payload: Payload): Promise<any> {
  try {
      const { data } = await httpClient.post<Data>(`/api/v1/employees`, payload);

    return data;
  } catch (error) {
      console.log(error);
    throw error;
  }
}

export async function editEmployee(id: Employee["id"], payload: Payload): Promise<boolean> {
    try {
        const response = await httpClient.put(`/api/v1/employees/${id}`, payload);

        return response.status === 200;
    } catch (error) {
        throw error;
    }
}

export const employee = {
    postEmployee,
    editEmployee,
};